import { Header } from "@/components/header";
import { SignedIn } from "@daveyplate/better-auth-ui";
import { createFileRoute, Outlet, redirect, useMatch } from "@tanstack/react-router";

export const Route = createFileRoute("/_app")({
  component: AppLayout,
  head: () => ({
    meta: [{ title: "Papier" }],
  }),
  beforeLoad: async ({ context: { queryClient, authOptions } }) => {
    const session = await queryClient.ensureQueryData(authOptions.session);
    if (!session) {
      throw redirect({
        to: "/auth/$authView",
        params: { authView: "sign-in" },
      });
    }

    if (!session.session.activeOrganizationId) {
      throw redirect({
        to: "/auth/$authView",
        params: { authView: "organization" },
      });
    }
  },
});

function AppLayout() {
  const editorMatch = useMatch({
    from: "/_app/projects/$projectSlug/templates/$templateSlug/edit",
    shouldThrow: false,
    select: (data) => data.id,
  });

  return (
    <SignedIn>
      {!editorMatch && <Header />}
      <div className="max-w-(--app-max-width) relative z-10 mx-auto min-h-screen px-4 py-6 pt-24">
        <Outlet />
      </div>
    </SignedIn>
  );
}
